// HomeNavbar.js
import { useState } from "react"
import { Link, NavLink } from "react-router-dom"
import { motion } from "framer-motion"
import { FaBars, FaTimes } from "react-icons/fa"

// Icon definition
const TrendingUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
)

// Button component
const Button = ({ children, size, variant, className, to }) => {
  const baseClasses =
    "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50"
  const sizeClasses = size === "lg" ? "h-11 px-8 py-3 text-base" : "h-10 px-4 py-2 text-sm"
  const variantClasses =
    variant === "outline"
      ? "border border-slate-600 text-white hover:bg-slate-800"
      : "bg-blue-600 hover:bg-blue-700 text-white"

  return to ? (
    <Link
      to={to}
      className={`${baseClasses} ${sizeClasses} ${variantClasses} ${className || ""}`}
    >
      {children}
    </Link>
  ) : (
    <button
      className={`${baseClasses} ${sizeClasses} ${variantClasses} ${className || ""}`}
    >
      {children}
    </button>
  )
}

export default function HomeNavbar() {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  return (
    <header className="z-50 py-6 px-4 md:px-6 lg:px-8 bg-slate-900 text-white sticky top-0 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 text-xl font-bold">
          <span className="text-blue-500">
            <TrendingUp />
          </span>
          <span>AlgoSoftware</span>
        </Link>

        {/* Desktop Links */}
        <nav className="hidden md:flex items-center gap-8">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `text-sm font-medium transition-colors ${
                isActive ? "text-white" : "text-slate-300 hover:text-white"
              }`
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about-us"
            className={({ isActive }) =>
              `text-sm font-medium transition-colors ${
                isActive ? "text-white" : "text-slate-300 hover:text-white"
              }`
            }
          >
            About
          </NavLink>
          <NavLink
            to="/services"
            className={({ isActive }) =>
              `text-sm font-medium transition-colors ${
                isActive ? "text-white" : "text-slate-300 hover:text-white"
              }`
            }
          >
            Services
          </NavLink>
          <NavLink
            to="/pricing"
            className={({ isActive }) =>
              `text-sm font-medium transition-colors ${
                isActive ? "text-white" : "text-slate-300 hover:text-white"
              }`
            }
          >
            Pricing
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `text-sm font-medium transition-colors ${
                isActive ? "text-white" : "text-slate-300 hover:text-white"
              }`
            }
          >
            Contact
          </NavLink>
          <Button to="/auth/register">Get Started</Button>
        </nav>

        {/* Mobile Menu Icon */}
        <div className="md:hidden flex items-center">
          <button className="outline-none focus:ring-2 focus:ring-blue-500" onClick={toggleMenu}>
            {isOpen ? (
              <FaTimes className="w-6 h-6 text-white" />
            ) : (
              <FaBars className="w-6 h-6 text-white" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Links */}
      <motion.div
        className={`md:hidden ${isOpen ? "block" : "hidden"} bg-slate-800`}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: isOpen ? 1 : 0, y: isOpen ? 0 : -20 }}
        transition={{ duration: 0.3 }}
      >
        <NavLink
          to="/"
          className={({ isActive }) =>
            `block py-2 px-4 text-sm transition-colors ${
              isActive ? "text-white bg-slate-700" : "text-slate-300 hover:bg-slate-700"
            }`
          }
          onClick={toggleMenu}
        >
          Home
        </NavLink>
        <NavLink
          to="/about-us"
          className={({ isActive }) =>
            `block py-2 px-4 text-sm transition-colors ${
              isActive ? "text-white bg-slate-700" : "text-slate-300 hover:bg-slate-700"
            }`
          }
          onClick={toggleMenu}
        >
          About
        </NavLink>
        <NavLink
          to="/services"
          className={({ isActive }) =>
            `block py-2 px-4 text-sm transition-colors ${
              isActive ? "text-white bg-slate-700" : "text-slate-300 hover:bg-slate-700"
            }`
          }
          onClick={toggleMenu}
        >
          Services
        </NavLink>
        <NavLink
          to="/pricing"
          className={({ isActive }) =>
            `block py-2 px-4 text-sm transition-colors ${
              isActive ? "text-white bg-slate-700" : "text-slate-300 hover:bg-slate-700"
            }`
          }
          onClick={toggleMenu}
        >
          Pricing
        </NavLink>
        <NavLink
          to="/contact"
          className={({ isActive }) =>
            `block py-2 px-4 text-sm transition-colors ${
              isActive ? "text-white bg-slate-700" : "text-slate-300 hover:bg-slate-700"
            }`
          }
          onClick={toggleMenu}
        >
          Contact
        </NavLink>
        <NavLink
          to="/auth/register"
          className="block py-2 px-4 text-sm text-white bg-blue-600 hover:bg-blue-700"
          onClick={toggleMenu}
        >
          Get Started
        </NavLink>
      </motion.div>
    </header>
  )
}